import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import Base from './Base';
import { SliderWrapper } from '../Input/Slider';
import { CheckboxWrapper } from '../Input/Checkbox';
import { RadioWrapper } from '../Input/Radio';
import { ToggleWrapper } from '../Input/Toggle';
import { CHECKBOX_LABEL_MARGIN } from '../Input/Checkbox/constants';
import { RADIO_LABEL_MARGIN } from '../Input/Radio/constants';
import { TOGGLE_LABEL_MARGIN } from '../Input/Toggle/constants';
import { SLIDER_LABEL_MARGIN } from '../Input/Slider/constants';
import { alignStyle } from '../Info/InfoWithIcons/style';
import { marginLeft } from '../style/margin-left';
import { marginRight } from '../style/margin-right';
const StyledLabel = styled(Base)`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: ${({
  $disabled
}) => !$disabled ? 'pointer' : 'not-allowed'};

  ${({
  $fullWidth
}) => $fullWidth && `width: 100%;`}

  & > ${CheckboxWrapper} {
    flex-shrink: 0;
    ${({
  $position,
  $marginRight: value
}) => ($position === 'left' || $position === 'between') && marginRight(value ?? CHECKBOX_LABEL_MARGIN)}
    ${({
  $position,
  $marginLeft: value
}) => ($position === 'right' || $position === 'between') && marginLeft(value ?? CHECKBOX_LABEL_MARGIN)}
    ${alignStyle}
  }
  & > ${SliderWrapper} {
    flex-shrink: 0;
    ${({
  $position,
  $marginRight: value
}) => ($position === 'left' || $position === 'between') && marginRight(value ?? SLIDER_LABEL_MARGIN)}
    ${({
  $position,
  $marginLeft: value
}) => ($position === 'right' || $position === 'between') && marginLeft(value ?? SLIDER_LABEL_MARGIN)}
    ${alignStyle}
  }
  & > ${RadioWrapper} {
    flex-shrink: 0;
    ${({
  $position,
  $marginRight: value
}) => ($position === 'left' || $position === 'between') && marginRight(value ?? RADIO_LABEL_MARGIN)}
    ${({
  $position,
  $marginLeft: value
}) => ($position === 'right' || $position === 'between') && marginLeft(value ?? RADIO_LABEL_MARGIN)}
    ${alignStyle}
  }
  & > ${ToggleWrapper} {
    flex-shrink: 0;
    ${({
  $position,
  $marginRight: value
}) => ($position === 'left' || $position === 'between') && marginRight(value ?? TOGGLE_LABEL_MARGIN)}
    ${({
  $position,
  $marginLeft: value
}) => ($position === 'right' || $position === 'between') && marginLeft(value ?? TOGGLE_LABEL_MARGIN)}
    ${alignStyle}
  }
`;
const Label = ({
  component: Component = Base,
  disabled = false,
  fullWidth = false,
  multiline = false,
  position = 'left',
  marginRight,
  marginLeft,
  mr,
  ml,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledLabel, _extends({
  as: "label",
  $disabled: disabled,
  $fullWidth: fullWidth,
  $multiline: multiline,
  $position: position
  // @ts-expect-error Special type
  ,
  $lineHeight: Component?._size?.lineHeight,
  $marginRight: marginRight ?? mr,
  $marginLeft: marginLeft ?? ml
}, props), children);
export default Label;